import "./styles/globals.css"

import Header from "./components/Header/Header"
import { Routes, Route } from "react-router-dom"
import AutologousMicrograftPage from "./pages/AutologousMicrograft/AutologousMicrograftPage"
import CorporatePage from "./pages/Corporate/CorporatePage"
import PatientGuidePage from "./pages/PatientGuide/PatientGuidePage"
import FAQPage from "./pages/FAQ/FAQPage"
import ResultsPage from "./pages/Results/ResultsPage"
import ContactPage from "./pages/Contact/ContactPage"
import SapphireFUEHairTransplantPage from "./pages/SapphireFUEHairTransplant/SapphireFUEHairTransplantPage"
import DHIHairTransplantPage from "./pages/DHIHairTransplant/DHIHairTransplantPage"
import RhinoplastyPage from "./pages/Rhinoplasty/RhinoplastyPage"
import Hero from "./components/Hero/Hero"
import YellowServices from "./components/YellowServices/YellowServices"
import LanguageComponent from "./components/LanguageComponent/LanguageComponent"
import NavyQuality from "./components/NavyQuality/NavyQuality"
import BlackStories from "./components/BlackStories/BlackStories"
import PreferredAndForm from "./components/PreferredAndForm/PreferredAndForm"
import BlueGallery from "./components/BlueGallery/BlueGallery"
import Reviews from "./components/Reviews/Reviews"
import TreatmentsBlock from "./components/TreatmentsBlock/TreatmentsBlock"
import BrandsMarquee from "./components/BrandsMarquee/BrandsMarquee"
import LatestArticles from "./components/LatestArticles/LatestArticles"
import Footer from "./components/Footer/Footer"
import FixedSocialIcons from "./components/FixedSocialIcons/FixedSocialIcons"
import FixedFormIcon from "./components/FixedFormIcon/FixedFormIcon"
import GoogleReviews from "./components/GoogleReviews/GoogleReviews"

export default function App() {
  return (
    <main className="page">
      <FixedSocialIcons />
      <FixedFormIcon />
      <Routes>
        <Route
          path="/"
          element={(
            <>
              <Header />
              <Hero />
              <YellowServices />
              <LanguageComponent />
              {/* <NavyQuality /> */}
              {/* <BlackStories /> */}
              <PreferredAndForm />
              <BlueGallery />
              <Reviews />
              {/* <GoogleReviews /> */}
              <TreatmentsBlock />
              <BrandsMarquee />
              {/* <LatestArticles /> */}
              <Footer />
            </>
          )}
        />
        <Route path="/autologous-micrograft" element={<AutologousMicrograftPage />} />
        <Route path="/sapphire-fue-hair-transplant" element={<SapphireFUEHairTransplantPage />} />
        <Route path="/dhi-hair-transplant" element={<DHIHairTransplantPage />} />
        <Route path="/rhinoplasty" element={<RhinoplastyPage />} />
        <Route path="/corporate" element={<CorporatePage />} />
        <Route path="/patient-guide" element={<PatientGuidePage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </main>
  )
}
